<div
  class="progress-bar"
  [ngClass]="[brand === 'VIVUS' ? 'vivus-style' : '']"
  *ngIf="!(activeIndex === 4) && !isMobile"
>
  <p-steps
    [model]="items"
    [readonly]="true"
    [activeIndex]="activeIndex"
  ></p-steps>
</div>

<div
  *ngIf="!(activeIndex === 4) && isMobile"
  class="progress-bar__mobile"
  [ngClass]="[brand === 'VIVUS' ? 'vivus-style' : '']"
>
  <span class="progress-bar__step-title">{{items[activeIndex].label}}</span>
  <div class="progress-bar__steps">
    <span [ngClass]="[activeIndex === 0 ? 'active-step' : 'step', 'default-step']" style="margin-left: 0"></span>
    <span [ngClass]="[activeIndex === 1 ? 'active-step' : 'step', 'default-step']"></span>
    <span [ngClass]="[activeIndex === 2 ? 'active-step' : 'step', 'default-step']"></span>
  </div>
  <span class="progress-bar__step-number">Шаг {{activeIndex + 1}}/3. Укажите ваши данные</span>
</div>
